<div class="current">

  <span>Saldo total</span>

  <div [ngClass]="{'ph-loading' : busyContent}"class="value">
    <div  [hidden]="showValue">{{ value | currency:'BRL':'symbol':'':'pt' }}</div>
    <bari-button (click)="toogleValueShow()" *ngIf="showValue" icon="eye" iconColor="#8E8E8E"></bari-button>
    <bari-button (click)="toogleValueShow()" *ngIf="!showValue" icon="eye-slash" iconColor="#8E8E8E"></bari-button>
  </div>

</div>
